import axios from "axios";
import { baseUrl, fcmUrl } from "api/baseUrl";

// 메인 API 클라이언트 (IIS 프록시 → ddukddaki.com:4989)
// X-API-Key 헤더는 IIS web.config의 serverVariables 규칙에서 서버측에서 주입한다.
// 따라서 클라이언트 코드에서 API 키를 다루지 않는다.
export const apiClient = axios.create({
  baseURL: baseUrl,
  timeout: 15000,
  headers: {
    "Content-Type": "application/json",
  },
});

// FCM 클라이언트 (IIS 프록시 → ddukddaki.com:3989). 인증 없음.
export const fcmClient = axios.create({
  baseURL: fcmUrl,
  timeout: 5000,
  headers: {
    "Content-Type": "application/json",
  },
});

// 백엔드는 업로드 파일을 "/uploads/..." 상대 경로로 돌려주지만 IIS/dev 프록시는
// "/api/*" 만 라우팅한다. "/api/uploads/..." 도 동일 파일을 서빙하므로 prefix 만 보정한다.
// 또한 옛날 데이터에는 절대 URL ("http://180.230.93.2:4989/uploads/..." 같은
// http 호스트 직지정) 이 섞여 있어 HTTPS 사이트에선 mixed-content 로 차단된다.
// 이런 URL 도 경로만 뽑아 /api/uploads/... 로 되돌려 IIS 프록시를 타게 한다.
export function toApiUrl(url) {
  if (!url || typeof url !== "string") return url;
  if (url.startsWith("data:") || url.startsWith("blob:")) return url;
  if (url.startsWith("/api/")) return url;
  if (url.startsWith("/uploads/")) return `/api${url}`;
  // 절대 URL 인 경우: 경로에서 "/uploads/..." 부분이 보이면 그것만 추출해 /api 로 보낸다.
  // (옛날 farm_server 직접 노출 URL, 또는 도메인이 바뀐 환경 모두 처리)
  const m = url.match(/^https?:\/\/[^/]+(\/(?:api\/)?uploads\/.+)$/i);
  if (m) {
    const path = m[1].startsWith("/api/") ? m[1] : `/api${m[1]}`;
    return path;
  }
  // 그 밖의 절대 URL 은 그대로 둔다 (예: 죽은 firebasestorage 링크는 어차피 클라이언트에서 복구 불가).
  return url;
}

export function toApiUrls(arr) {
  if (!Array.isArray(arr)) return arr;
  return arr.map(toApiUrl);
}

// 공통 에러 로깅
apiClient.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url;
    if (status === 403) {
      console.error(`[apiClient] 403 Forbidden — ${url} (IIS API 키 주입 확인 필요)`);
    } else {
      console.error(`[apiClient] ${status || "network"} — ${url}`, err?.message);
    }
    return Promise.reject(err);
  },
);
